import { hexToRgb, getLuminance, safe } from '../utils/contrast.js';
import { estiloDeBoton } from '../utils/boton-estilo.js';
import { ctaAnchorAttrs } from '../utils/links.js';
import { conSecundario } from '../utils/boton-secundario.js';
import { t } from '../utils/i18n.js';

// Bloque CTA Bar — barra fija de conversión.
//   v1/v2 = fija al FONDO de la pantalla (barra flotante / píldora glass).
//   v3     = barra de ANUNCIO fija ARRIBA (announcement bar): la delegación de
//            core/block-actions.js la "iza" al viewport y baja el header para que
//            no se solapen; su cierre se PERSISTE en localStorage.
export const ctaBarBlock = (rawProps) => {
    const p = safe(rawProps);
    const variant = p.variant || 'v1';
    const isTop = variant === 'v3';
    const text = p.text || '¡Oferta por tiempo limitado! Contáctanos hoy.';
    const cta = p.cta || 'Contactar Ahora';
    const ctaUrl = p.cta_url || '#';
    const bg = p.bgColor || '#1a1a2e';
    const fg = p.textColor || '#ffffff';
    const accent = p.accentColor || '#6366f1';

    // CSS vars centralizadas para herencia — ambas vistas las usan
    const cssVars = `--bg:${bg}; --text:${fg}; --accent:${accent}; --font:'${p.fontFamily || "Inter"}'; --accent-contrast:${p.accentContrast};`;

    // El borde de acento va arriba (barra inferior) o abajo (barra superior) según la variante.
    const borderSide = isTop ? 'border-bottom' : 'border-top';
    const hint = isTop
        ? '(Esta barra de anuncio se fijará en la parte SUPERIOR de la pantalla al "Ver Sitio")'
        : '(Esta barra se fijará en la parte inferior de la pantalla al "Ver Sitio")';
    const editorLabel = isTop ? '📣 Barra de Anuncio Superior (Announcement Bar)' : '📣 Barra Flotante de Conversión (CTA Bar)';

    return `
    <!-- VISTA EDITOR (En el flujo normal de la página) -->
    <div class="editor-only cta-bar-editor" style="${cssVars} background: var(--bg); color: var(--text);">
        <div style="font-size: calc(0.75rem * var(--type-scale, 1)); font-weight: 800; opacity: 0.5; margin-bottom: 15px; letter-spacing: var(--kicker-tracking, 2px); text-transform: var(--kicker-case, uppercase);">${editorLabel}</div>
        <div style="display: flex; align-items: center; justify-content: center; gap: 20px; flex-wrap: wrap;">
            <p data-field="text" contenteditable="true" style="margin:0; font-size:calc(1.1rem * var(--text-scale, 1)); font-weight:600; opacity:0.9;">${text}</p>
            ${conSecundario(`<a ${ctaAnchorAttrs(ctaUrl)} class="btn-action" data-field="cta" contenteditable="true" style="${estiloDeBoton(p, 'cta')}padding: calc(12px * var(--n3b-k, 1)) calc(24px * var(--n3b-k, 1)); font-size: calc(0.9rem * var(--n3b-k, 1));">${cta}</a>`, p, { boton: 'padding: calc(12px * var(--n3b-k, 1)) calc(24px * var(--n3b-k, 1)); font-size: calc(0.9rem * var(--n3b-k, 1));' })}
        </div>
        <div style="font-size: 0.8rem; opacity: 0.6; margin-top: 15px;">${hint}</div>
    </div>

    <!-- VISTA SITIO REAL (Barra fija) -->
    <div class="cta-sticky-bar preview-only variant-${variant}"
         style="${cssVars} background: var(--bg); color: var(--text); ${borderSide}: 2px solid color-mix(in srgb, var(--accent) 20%, transparent);">
        <p class="cta-bar-text" style="margin:0; font-size:calc(0.95rem * var(--text-scale, 1)); font-weight:600; opacity:0.9;">${text}</p>
        ${conSecundario(`<a ${ctaAnchorAttrs(ctaUrl, { editable: false })}
           class="cta-bar-btn btn-action"
           style="${estiloDeBoton(p, 'cta')}white-space:nowrap;">
            ${cta}
        </a>`, p, { editable: false, clase: 'cta-bar-btn2 btn-action btn-secundario' })}
        <button class="cta-bar-close" type="button" title="${t('close')}">✕</button>
    </div>`;
};
